import * as React from 'react';

import AppsIcon from '@mui/icons-material/Apps';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { track } from '@hbf/analytics';

import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { SearchView } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { ListingsSearchAllowedSearchViews } from '@kamernet/core/Routing/routes/ListingsSearch';

import { ListingsSearchContext } from '../../ListingsSearchContext';
import { SearchViewTranslations } from '../../translations';

import styles from './SearchViewToggleButton.module.css';

const icons: Record<SearchView, React.ReactElement> = {
  [SearchView.Empty]: <AppsIcon />,
  [SearchView.List]: <AppsIcon />,
  [SearchView.Map]: <LocationOnOutlinedIcon />,
  [SearchView.Favorite]: <AppsIcon />,
};

export const SearchViewToggleButton = () => {
  const { T } = useIntl();
  const { allFilters, applyNewAllFilters } = ListingsSearchContext.useContext();

  const handleViewChange = React.useCallback(
    (_: React.SyntheticEvent, newSearchView: SearchView) => {
      if (newSearchView) {
        track(AnalyticsEvent.ClickedChangeView, {
          name: newSearchView === SearchView.List ? 'list view' : 'map view',
        });

        applyNewAllFilters({
          searchView: newSearchView,
          nwlat: 0,
          nwlng: 0,
          selat: 0,
          selng: 0,
          mapZoom: 0,
        });
      }
    },
    [applyNewAllFilters],
  );

  const controlProps = {
    value: allFilters.searchView,
    onChange: handleViewChange,
    exclusive: true,
  };

  return (
    <ToggleButtonGroup
      {...controlProps}
      value={allFilters.searchView}
      className={styles.root}
    >
      {ListingsSearchAllowedSearchViews.map(searchView => {
        return (
          <ToggleButton key={searchView} value={searchView}>
            {icons[searchView]}
            <Typography variant="body3">
              {T(SearchViewTranslations[searchView])}
            </Typography>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};
